const traverseAndSetObject = <T extends { [key: string]: any }>(
    object: T,
    traverseKey: string, // in the form of "{key_1}: ... : {key_n}",
    newValue: any
) => {
    const splitKey = traverseKey.split(":");
    const lastIdx = splitKey.slice(-1)[0];
    const relativeParent = splitKey
        .slice(0, -1)
        .reduce((acc, curr) => acc[curr], object);
    (relativeParent as Record<string, any>)[lastIdx] = newValue;
    return object;
};

export default traverseAndSetObject;
